<template>
  <section
    ref="container"
    class="p-invitation"
  >
    <h1 class="p-invitation__title a-font__h1">
      Пригласить друга
    </h1>
    <p class="p-invitation__txt a-font__l">
      Выбери один из вариантов для приглашения:
    </p>
    <div class="p-invitation__btn-group">
      <BaseButton
        class="m_w311 mm_w100p"
        @click="invitePage"
      >
        Онлайн-анкета
      </BaseButton>
    </div>
  </section>
</template>

<script lang="ts">
import './p_invitation.scss';
import AppPopupInvitation from '@/shared/components/AppPopupInvitation/AppPopupInvitation.vue';
import { defineComponent } from 'vue';
import BaseButton from '@/shared/lib/uikit/components/BaseButton/BaseButton.vue';

export default defineComponent({
  name: 'PInvitation',
  components: { BaseButton },
  extends: AppPopupInvitation,
});
</script>
